import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import PolicyIcon from "@material-ui/icons/Policy";
import InfoIcon from "@material-ui/icons/Info";
import SettingsIcon from "@material-ui/icons/Settings";

export const sidebarRoutes = [
  {
    path: "/search",
    labelKey: "busqueda",
    icon: SearchIcon,
  },
  {
    path: "/guide",
    labelKey: "guia-usuario",
    icon: DescriptionIcon,
  },
  {
    path: "/privacy",
    labelKey: "politica-privacidad",
    icon: PolicyIcon,
    privacyConditional: true,
  },
  {
    path: "/about",
    labelKey: "about",
    icon: InfoIcon,
  },
  {
    path: "/settings",
    labelKey: "ajustes",
    icon: SettingsIcon,
  },
];